import { apiClient, unwrap } from './client';

/**
 * SIMG-DEMANDE-TERRAIN-2026-001 — demandes d'achat venues des chantiers.
 */

export type StatutDemande = 'soumise' | 'en_traitement' | 'convertie' | 'refusee';
export type UrgenceDemande = 'normale' | 'urgente';
export type NatureLigne = 'matiere_premiere' | 'fourniture' | 'service' | 'immobilisation';

export interface LigneDemande {
  id:                       string;
  designation:              string;
  quantite:                 string;
  unite:                    string;
  nature:                   NatureLigne;
  categorieImmobilisation:  string | null;
  matierePremiereId:        string | null;
  matierePremiere?:         { id: string; code: string; nom: string; unite: string } | null;
  notes:                    string | null;
}

export interface Demande {
  id:              string;
  reference:       string;
  statut:          StatutDemande;
  urgence:         UrgenceDemande;
  origine:         string;
  demandeurNom:    string;
  motif:           string;
  motifRefus:      string | null;
  bonCommandeId:   string | null;
  createdAt:       string;
  traiteLe:        string | null;
  site?:           { id: string; code: string; libelle: string } | null;
  lignes:          LigneDemande[];
}

export interface CompteursDemandes {
  soumises:     number;
  urgentes:     number;
  enTraitement: number;
}

export const demandesApi = {
  lister: (statut?: StatutDemande) =>
    apiClient
      .get('/achats/demandes', { params: statut ? { statut } : undefined })
      .then(unwrap<Demande[]>),

  compteurs: () =>
    apiClient.get('/achats/demandes/compteurs').then(unwrap<CompteursDemandes>),

  prendreEnCharge: (id: string) =>
    apiClient.post(`/achats/demandes/${id}/prendre-en-charge`).then(unwrap<Demande>),

  convertir: (id: string, body: {
    fournisseurId: string;
    prix: Array<{ ligneId: string; prixUnitaireCents: number }>;
    tvaPct?: number;
  }) =>
    apiClient.post(`/achats/demandes/${id}/convertir`, body)
      .then(unwrap<{ id: string; reference: string; demandeReference: string }>),

  refuser: (id: string, motif: string) =>
    apiClient.post(`/achats/demandes/${id}/refuser`, { motif }).then(unwrap<Demande>),
};
